import React from "react";
import { Link } from "@/components/common/Link";
import { ArrowRight, MessageSquare, PhoneCall, FileText, BadgeDollarSign, CalendarCheck2, Megaphone } from "lucide-react";
interface ServiceItem {
  icon: React.ReactNode;
  title: string;
  description: string;
  link: string;
  isInternalAnchor: boolean;
  linkLabel?: string;
}
const services: ServiceItem[] = [{
  icon: <MessageSquare className="h-6 w-6 text-primary-foreground" />,
  title: "Asistente IA en WhatsApp y chat",
  description: "Responde a sus clientes al instante, a cualquier hora, y pasa a una persona cuando hace falta.",
  link: "/OmnichannelPage",
  isInternalAnchor: false,
  linkLabel: "Saber más"
}, {
  icon: <PhoneCall className="h-6 w-6 text-primary-foreground" />,
  title: "Atención de llamadas con IA",
  description: "Contesta, orienta y registra las llamadas para que ninguna se pierda.",
  link: "/OmnichannelPage",
  isInternalAnchor: false,
  linkLabel: "Saber más"
}, {
  icon: <FileText className="h-6 w-6 text-primary-foreground" />,
  title: "Transcripción y análisis de conversaciones",
  description: "Sepa qué se dice a sus clientes y detecte problemas y oportunidades.",
  link: "/TranscriptionAndAnalysisOfChatsAndCallsPage",
  isInternalAnchor: false,
  linkLabel: "Saber más"
}, {
  icon: <BadgeDollarSign className="h-6 w-6 text-primary-foreground" />,
  title: "Cobranza y recordatorios automáticos",
  description: "Avisos de pago y seguimiento sin trabajo manual, para cobrar a tiempo.",
  link: "#contacto",
  isInternalAnchor: true,
  linkLabel: "Pedir información"
}, {
  icon: <CalendarCheck2 className="h-6 w-6 text-primary-foreground" />,
  title: "Reservas y citas automáticas",
  description: "Sus clientes reservan, confirman y reprograman solos.",
  link: "#contacto",
  isInternalAnchor: true,
  linkLabel: "Pedir información"
}, {
  icon: <Megaphone className="h-6 w-6 text-primary-foreground" />,
  title: "Campañas y avisos a clientes",
  description: "Informe de productos y promociones por los canales que sus clientes ya usan.",
  link: "/OmnichannelPage",
  isInternalAnchor: false,
  linkLabel: "Saber más"
}];
export default function ServiciosClave() {
  return <section data-section-id="259183" id="servicios-clave" className="bg-background py-16 md:py-24 text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="mb-12 md:mb-16 text-center max-w-3xl mx-auto">
          <h2 className="mb-4 text-3xl md:text-4xl font-bold font-default tracking-tight text-foreground">
            Lo que AVTECSA automatiza por usted
          </h2>
          <p className="font-default text-lg text-muted-foreground">
            Soluciones de IA sobre sus canales de comunicación, para ahorrar tiempo y atender mejor.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service, i) => <div key={i} data-index={i} className="flex flex-col items-center rounded-md border border-border bg-card p-8 text-center shadow-sm transition-all duration-300 hover:-translate-y-2 hover:border-primary hover:shadow-xl">
              <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-sm">
                {service.icon}
              </div>

              <h3 className="mb-3 text-xl font-bold font-default tracking-tight text-card-foreground">
                {service.title}
              </h3>

              <p className="mb-6 flex-grow font-default text-base text-muted-foreground leading-relaxed">
                {service.description}
              </p>

              <Link to={service.link} className="group inline-flex items-center font-default text-sm font-semibold uppercase tracking-wider text-secondary transition-colors hover:text-secondary/80">
                {service.linkLabel ?? (service.isInternalAnchor ? "Pedir información" : "Saber más")}
                <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}